import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useState } from "react";
import { Grid, makeStyles, Paper } from "@material-ui/core";
import { addRegisteredSectionLayout } from "../sectionLayoutDescriptions";
import { useCalculationFields } from "@ploy-lib/calculation";
import clsx from "clsx";
import { FormHelperTextContainerWrapper, HelperTextIconButton } from "../..";
import { MarkdownElement, useFormatRuntimeMessage } from "@ploy-ui/core";
import { useTenant } from "@ploy-ui/tenants";
import { useIntl } from "react-intl";
addRegisteredSectionLayout({
    name: "MarkdownSection",
    displayName: "MarkdownSection",
    settings: {
        editableOptions: {
            mainText: true,
            standardMargin: true,
            centerText: true,
            helperText: true
        }
    }
});
const useStyles = makeStyles((theme) => ({
    root: {
        margin: "0 auto",
        backgroundColor: "inherit"
    },
    standardMargin: {
        maxWidth: "550px"
    },
    centerText: {
        textAlign: "center",
        justifyContent: "center"
    },
    outline: ({ outline, square }) => ({
        border: `1px solid ${(outline && theme.palette[outline] && theme.palette[outline].main) ||
            theme.palette.secondary.main}`
    }),
    outlineWidth: ({ outlineWidth }) => ({
        borderWidth: outlineWidth
    }),
    body: {
        "& > p": {
            marginBlockStart: `${theme.spacing(0.5)}px`,
            marginBlockEnd: `${theme.spacing(0.5)}px`,
            lineHeight: "24px",
            fontSize: theme.typography.body1.fontSize
        },
        "& > h4": {
            fontWeight: theme.typography.h4.fontWeight,
            fontSize: theme.typography.h4.fontSize,
            marginBlockStart: `${theme.spacing(1)}px`,
            marginBlockEnd: `${theme.spacing(1)}px`
        },
        "& > h6": {
            fontWeight: theme.typography.h6.fontWeight,
            fontSize: theme.typography.h6.fontSize,
            marginBlockStart: `${theme.spacing(0.75)}px`,
            marginBlockEnd: `${theme.spacing(0.75)}px`
        }
    }
}), { name: "DployMarkdownSection" });
export function MarkdownSection(props) {
    const { mainText = "", standardMargin = false, centerText = false, allFields = [], className, onClick, helperText = "", elevation = 0, outline, outlineWidth, fullWidth } = props;
    const { formatNumber } = useIntl();
    const { tenant } = useTenant();
    const images = tenant?.images ?? {};
    const firstImages = {};
    Object.keys(images).forEach(key => {
        firstImages[key] = images[key][0];
    });
    const calculationFields = useCalculationFields(...allFields.map(f => ({ name: f.name, namespace: f.namespace })));
    const mainTextValues = calculationFields.reduce((acc, field, index) => {
        const value = field?.value?.toString() ?? field?.fieldValue?.toString() ?? "";
        const fieldName = allFields[index].name;
        const renderAsComponent = allFields[index].renderAs;
        const maximumDigits = allFields[index].maximumFractionDigits ?? 0;
        if (renderAsComponent === "CurrencyField")
            acc[fieldName] = formatNumber(Number(value), {
                format: "currency"
            });
        else if (renderAsComponent === "PercentField")
            acc[fieldName] = formatNumber(Number(value), {
                format: "percent",
                maximumFractionDigits: maximumDigits
            });
        else if (renderAsComponent === "NumberField")
            acc[fieldName] = formatNumber(Number(value), {
                maximumFractionDigits: maximumDigits
            });
        else
            acc[fieldName] = value;
        return acc;
    }, {});
    const formatMessage = useFormatRuntimeMessage();
    const message = formatMessage(mainText, { ...mainTextValues, ...firstImages }, {
        ignoreTag: true
    });
    const classes = useStyles(props);
    const [showHelperText, setShowHelperText] = useState(false);
    return (_jsxs(Grid, { component: Paper, elevation: elevation, className: clsx(className, classes.root, {
            [classes.standardMargin]: standardMargin,
            [classes.centerText]: centerText,
            [classes.outline]: outline,
            [classes.outlineWidth]: outlineWidth
        }), onClick: onClick, xs: 12, item: true, container: true, children: [_jsx(Grid, { item: true, xs: fullWidth ? 12 : 11, children: _jsx(MarkdownElement, { text: message }) }), helperText && (_jsx(HelperTextIconButton, { toggleHelperText: () => setShowHelperText(display => !display), showHelperText: showHelperText })), _jsx(Grid, { item: true, container: true, xs: 12, children: showHelperText && helperText ? (_jsx(FormHelperTextContainerWrapper, { helperText: helperText })) : null })] }));
}
//# sourceMappingURL=MarkdownSection.js.map